import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseModalComponent } from './components/base-modal/base-modal.component';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { FormsModule } from '@angular/forms';
import { FocusInputDirective } from './directives/focus-input.directive';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  imports: [CommonModule, SharedUiButtonsModule, FormsModule, SharedUiIconsModule, DialogModule],
  declarations: [BaseModalComponent, FocusInputDirective],
  exports: [BaseModalComponent],
})
export class SharedUiModalModule {}
